import React, { useEffect, useState } from 'react'
import './services.css'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import OurServices from '../Index/OurServices'

import Cloud1 from '../../assets/cloud-1.svg'
import Cloud2 from '../../assets/cloud-2.svg'
import TyC from '../../components/TyC/TyC'
import BtnWhatsapp from '../../components/BtnWhatsapp/BtnWhatsapp'
import useSeo from '../../hooks/useSeo'
const Services = () => {
  const [socials] = useState({
    wpp: 'https://api.whatsapp.com/send?phone=5491161670393&text=Hola%2C+buenas+tardes%21+Tengo+una+consulta',
    ig: 'https://www.instagram.com/colibri_premium/',
    fb: ''
  })

  useSeo({
    titulo: 'Servicios técnicos para dispositivos Apple',
    descripcion:
      'Cambio de pantalla, batería, glass y reparación de placa en iPhone, MacBook, iPad y Apple Watch. Diagnóstico y presupuesto sin cargo en Capital Federal.',
    ruta: '/servicios'
  })
  return (
    <div className='services'>
      <Header />
      <div className='container-services'>
        <BtnWhatsapp linkWpp={socials.wpp} />
        <img
          className='cloud cloud-left animate__animated animate__fadeIn animate__delay-01s'
          src={Cloud1}
          alt=''
        />
        <OurServices form={true} />
        <img
          className='cloud cloud-right animate__animated animate__fadeIn animate__delay-01s'
          src={Cloud2}
          alt=''
        />
      </div>

      <TyC />

      <Footer />
    </div>
  )
}

export default Services
